<template>
    <span ref="container"></span>
</template>

<script>
export default {
    name: "TypewriterText",
    props: {
        text: {
            type: [String, Number],
            required: true,
            validator: (value) => {
                // Permite string, number ou null/undefined (será convertido para string vazia)
                return (
                    typeof value === "string" ||
                    typeof value === "number" ||
                    value == null
                );
            },
        },
        speed: {
            type: Number,
            default: 50,
        },
    },
    mounted() {
        this.startTyping();
    },
    methods: {
        startTyping() {
            const container = this.$refs.container;
            // Converte para string e usa fallback vazio se necessário
            const text = String(this.text || "").trim();
            

            // Sai se não há texto para digitar
            if (!text) return;

            let index = 0;

            const type = () => {
                if (index < text.length) {
                    container.textContent += text.charAt(index);
                    index++;
                    setTimeout(type, this.speed);
                }
            };

            type();
        },
    },
};
</script>
